/* Tree House Deco · Armá tu pared (simulador de composiciones)
   Se carga desde sections/arma-tu-pared.liquid. Todo el simulador vive dentro de un
   "shadow DOM" para que los estilos del tema y los del simulador no se mezclen. */
(function(){
'use strict';
const host=document.getElementById('atp-host');
if(!host||host.shadowRoot)return;
const CFG=JSON.parse(document.getElementById('atp-config').textContent);
const root=host.attachShadow({mode:'open'});
root.appendChild(document.getElementById('atp-template').content.cloneNode(true));
const $=id=>root.getElementById(id);

/* ---------- catálogo ---------- */
const CAT=[], BYID={};
const TABS={};                         // título de pestaña -> [handles] (se cargan al abrirla)
const FRAMES={NAT:{n:'Natural',c:'#C9A274',hi:'#DDBB8E'},NEG:{n:'Negro',c:'#1F1E1C',hi:'#3A3835'},NOG:{n:'Nogal',c:'#5B3B24',hi:'#7A5236'},SM:{n:'Sin marco',c:'#E3D3B5',hi:'#E3D3B5'}};
const WALLS=[['#EFEBE4','Blanco tiza'],['#CDD3C4','Salvia'],['#C7CED4','Gris azulado'],['#E6D2C2','Rosa arcilla'],['#4A5446','Verde bosque']];
const fmt=n=>'$'+Math.round(n).toLocaleString('es-UY');
const cm=s=>s.split('X').map(Number);
const ROOT=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
let BEST=[];

async function fetchJSON(url){const r=await fetch(url,{credentials:'same-origin'});if(!r.ok)throw new Error(url+' '+r.status);return r.json();}
// trae todas las páginas de una colección con la plantilla alternativa ("view")
async function loadCollection(handle,view){
  const u=p=>`${ROOT}collections/${handle}?view=${view}&page=${p}`;
  const first=await fetchJSON(u(1)); let out=first.p.slice();
  const rest=[]; for(let p=2;p<=(first.pages||1);p++)rest.push(fetchJSON(u(p)));
  (await Promise.all(rest)).forEach(j=>out=out.concat(j.p));
  return out;
}
function parseProduct(p){
  const sku=(p.k||'').toUpperCase();
  const m=sku.match(/^(?:MDF-)?S(\d)-/); const n=m?Math.max(1,+m[1]):1;
  const v={}; let mdf=sku.startsWith('MDF-');
  const sizes=[];
  p.v.forEach(([id,title,cents])=>{
    const parts=String(title).toUpperCase().split(' / ').map(x=>x.trim());
    const size=parts.find(x=>/^\d+X\d+$/.test(x)); if(!size)return;
    const gl=parts.find(x=>/VIDRIO/.test(x)); const fr=parts.find(x=>/NATURAL|NEGRO|NOGAL/.test(x));
    if(!gl&&!fr)mdf=true;
    const key=(gl||fr)?`${size}|${/SIN/.test(gl||'')||!gl?'SV':'VC'}|${/NEGRO/.test(fr||'')?'NEG':/NOGAL/.test(fr||'')?'NOG':'NAT'}`:size;
    if(!v[key])v[key]=[id,cents/100];
    if(!sizes.includes(size))sizes.push(size);
  });
  sizes.sort((a,b)=>cm(a)[0]*cm(a)[1]-cm(b)[0]*cm(b)[1]);
  const tags=p.g||[];
  const ordT=tags.find(t=>/^simu-orden-[abc]{2,3}$/.test(t));
  const rot=tags.includes('simu-rot-izq')?-90:tags.includes('simu-rot-der')?90:0;
  const sets=tags.filter(t=>/^set\d/.test(t));
  const t=p.t.replace(/^(Set x\d )?Cuadros? Decorativos? /i,'').replace(/^Abstractos?, /,'').replace(/^Modernos, /,'');
  return {id:p.h,h:p.h,t,n,mdf,v,sizes,rot,ord:ordT?ordT.slice(11):'',hz:rot!==0,sets,p:[],col:''};
}
function imgBase(it,k){return `${CFG.files}SIMU-${it.h}${it.n>1?'-'+(it.ord||'abc')[k]:''}.${it.ext||'jpg'}`;}

/* imágenes: las que están guardadas giradas se enderezan en el navegador */
const _rot={};
function rotated(url,deg){
  if(_rot[url])return _rot[url];
  return _rot[url]=new Promise(res=>{const im=new Image();im.crossOrigin='anonymous';
    im.onload=()=>{try{const c=document.createElement('canvas');c.width=im.height;c.height=im.width;const x=c.getContext('2d');
      x.translate(c.width/2,c.height/2);x.rotate(deg*Math.PI/180);x.drawImage(im,-im.width/2,-im.height/2);
      c.toBlob(b=>res(b?URL.createObjectURL(b):url),'image/jpeg',.85);}catch(e){res(url);}};
    im.onerror=()=>res(url); im.src=url;});
}
const _ready={};
function imgURL(it,k,w){
  const u=imgBase(it,k)+'?width='+w;
  if(!it.rot)return u;
  const key=u; if(_ready[key])return _ready[key];
  rotated(u,it.rot).then(b=>{_ready[key]=b;scheduleRender();});
  return '';
}
// si el archivo ya es horizontal (más ancho que alto) lo detectamos solo
const _probed={};
function probe(it){
  if(_probed[it.id])return; _probed[it.id]=1;
  const im=new Image();
  im.onload=()=>{if(!it.rot&&im.naturalWidth>im.naturalHeight*1.05){it.hz=true;flow();}};
  // algunos originales se guardaron como .png: si el .jpg no existe, usa el .png
  im.onerror=()=>{if((it.ext||'jpg')==='jpg'){it.ext='png';_probed[it.id]=0;probe(it);scheduleRender();}};
  im.src=imgBase(it,0)+'?width=80';
}
let _rq=0; function scheduleRender(){if(_rq)return;_rq=requestAnimationFrame(()=>{_rq=0;render();hydrate(root);});}
function thumbs(it,w){
  w=w||360;
  return Array.from({length:it.n},(_,k)=>{
    const u=imgBase(it,k)+'?width='+w;
    return it.rot?`<img alt="" decoding="async" data-rot="${it.rot}" data-u="${u}">`:`<img alt="" loading="lazy" decoding="async" src="${u}">`;
  }).join('');
}
function oneThumb(it,k,w){const u=imgBase(it,k)+'?width='+w;return it.rot?`<img alt="" data-rot="${it.rot}" data-u="${u}">`:`<img alt="" src="${u}">`;}
// miniaturas: si el .jpg no existe, prueba con el .png
root.addEventListener('error',e=>{const im=e.target;if(im&&im.tagName==='IMG'&&/\/SIMU-[^?]*\.jpg\?/.test(im.src)){im.src=im.src.replace(/\.jpg\?/,'.png?');}},true);
function hydrate(el){el.querySelectorAll('img[data-rot]:not([src])').forEach(im=>{rotated(im.dataset.u,+im.dataset.rot).then(b=>{im.src=b;});});}

/* ---------- composición ---------- */
const ARR={line:'En línea',grid:'En grilla',gal:'Galería'};
function arrOptions(n){const o=['line'];if(n>=4)o.push('grid');if(n===5)o.push('gal');return o;}
function defaultArr(n){return n<=3?'line':n===5?'gal':'grid';}
function arrIcon(k,n){
  let r=[];
  if(k==='line'){const w=Math.min(12,48/n-2);const tot=n*w+(n-1)*2;let x=(56-tot)/2;for(let i=0;i<n;i++){r.push([x,8,w,16]);x+=w+2;}}
  else if(k==='grid'){const c=Math.ceil(n/2),w=Math.min(11,44/c-2);const tot=c*w+(c-1)*2;for(let i=0;i<n;i++){const ci=i%c,ri=Math.floor(i/c);r.push([(56-tot)/2+ci*(w+2),2+ri*15,w,13]);}}
  else r=[[4,3,11,12],[4,17,11,12],[19,1,18,30],[41,3,11,12],[41,17,11,12]];
  return `<svg viewBox="0 0 56 32" aria-hidden="true">${r.map(q=>`<rect x="${q[0]}" y="${q[1]}" width="${q[2]}" height="${q[3]}" rx="1"/>`).join('')}</svg>`;
}
const GAP=6;
const st={wall:1,wallW:320,furn:'sofa',arr:'line',slots:[],active:0,nextGroup:1,gx:0,gy:0,
  entry:'direct',viewed:[],photo:null,pins:[.1,.9],pinY:.8,calibCm:0,pinsMoved:false,calibrating:false};

function mkSlot(size){return{item:null,piece:0,group:null,size,glass:'SV',frame:'NAT',margin:false,dx:0,dy:0};}
const MAXN=8;
function cleanSets(){const g={};st.slots.forEach(s=>{if(s.group)g[s.group]=(g[s.group]||0)+1;});
  st.slots.forEach(s=>{if(s.group&&g[s.group]<BYID[s.item].n){s.item=null;s.group=null;s.piece=0;}});}
function setCount(n){
  n=Math.max(1,Math.min(MAXN,n));
  while(st.slots.length<n){const last=st.slots[st.slots.length-1];st.slots.push(mkSlot(last&&!(last.item&&BYID[last.item].mdf)?last.size:(n>=4?'30X40':'40X50')));}
  while(st.slots.length>n)st.slots.pop();
  cleanSets();
  if(!arrOptions(n).includes(st.arr))st.arr=defaultArr(n);
  st.active=Math.min(st.active,n-1); st.gx=0; st.gy=0; renderStatic(); flow();
}
function initSlots(n,size){st.slots=Array.from({length:n},()=>mkSlot(size));st.arr=defaultArr(n);}
function orientOf(s){const it=s.item&&BYID[s.item];return it&&it.hz?'h':'v';}
function sizeLabel(s){const [a,b2]=cm(s.size);return orientOf(s)==='h'?`${b2}x${a}`:`${a}x${b2}`;}
function dimsOf(s){const [w,h]=cm(s.size);return orientOf(s)==='h'?{w:h,h:w}:{w,h};}
function flow(){
  const S=st.slots; if(!S.length)return; if(st.arr==='custom'&&!(st.custom&&st.custom.length===S.length))st.arr=defaultArr(S.length); if(st.arr!=='custom'&&!arrOptions(S.length).includes(st.arr))st.arr=defaultArr(S.length);
  const L={kind:st.arr,cols:Math.ceil(S.length/2)}; S.forEach(s=>{s.dx=0;s.dy=0;});
  const pos=[];
  if(L.kind==='line'){
    const tw=S.reduce((a,s)=>a+dimsOf(s).w,0)+GAP*(S.length-1); let x=-tw/2;
    S.forEach(s=>{const d=dimsOf(s);pos.push([x+d.w/2,0]);x+=d.w+GAP;});
  }else if(L.kind==='grid'){
    const c=L.cols, rows=Math.ceil(S.length/c), cw=[], rh=[];
    S.forEach((s,i)=>{const d=dimsOf(s);cw[i%c]=Math.max(cw[i%c]||0,d.w);rh[Math.floor(i/c)]=Math.max(rh[Math.floor(i/c)]||0,d.h);});
    const tw=cw.reduce((a,b)=>a+b,0)+GAP*(c-1), th=rh.reduce((a,b)=>a+b,0)+GAP*(rows-1);
    S.forEach((s,i)=>{const ci=i%c,ri=Math.floor(i/c);let x=-tw/2,y=-th/2;for(let k=0;k<ci;k++)x+=cw[k]+GAP;for(let k=0;k<ri;k++)y+=rh[k]+GAP;pos.push([x+cw[ci]/2,y+rh[ri]/2]);});
  }else if(L.kind==='custom'){
    st.custom.forEach(q=>pos.push([q.x,q.y]));
  }else{
    const c=dimsOf(S[2]),l=[S[0],S[1]].map(dimsOf),r=[S[3],S[4]].map(dimsOf);
    const lw=Math.max(l[0].w,l[1].w),rw=Math.max(r[0].w,r[1].w),lh=l[0].h+l[1].h+GAP,rh=r[0].h+r[1].h+GAP;
    const lx=-c.w/2-GAP-lw/2,rx=c.w/2+GAP+rw/2;
    pos[0]=[lx,-lh/2+l[0].h/2];pos[1]=[lx,lh/2-l[1].h/2];pos[2]=[0,0];pos[3]=[rx,-rh/2+r[0].h/2];pos[4]=[rx,rh/2-r[1].h/2];
  }
  S.forEach((s,i)=>{s.cx=pos[i][0];s.cy=pos[i][1];});
  render();
}

/* ---------- escena ---------- */
const stage=$('stage'), slotsEl=$('slots'), pinsEl=$('pins');
const FURN={sofa:{w:200,h:82},aparador:{w:160,h:78},cama:{w:160,h:105},none:{w:0,h:0}};
const WALL_H=260, FLOOR_CM=18;
let scale=1, cxPx=0, cyPx=0;
function furnSVG(k,w,h){
  const c='#6F6A60',c2='#827C71',leg='#3B362F';
  if(k==='sofa')return `<svg viewBox="0 0 200 82" width="${w}" height="${h}" preserveAspectRatio="none" aria-hidden="true"><rect x="8" y="10" width="184" height="42" rx="10" fill="${c2}"/><rect x="0" y="34" width="22" height="40" rx="8" fill="${c}"/><rect x="178" y="34" width="22" height="40" rx="8" fill="${c}"/><rect x="18" y="46" width="164" height="26" rx="6" fill="${c}"/><rect x="22" y="44" width="78" height="10" rx="5" fill="${c2}"/><rect x="100" y="44" width="78" height="10" rx="5" fill="${c2}"/><rect x="14" y="74" width="5" height="8" fill="${leg}"/><rect x="181" y="74" width="5" height="8" fill="${leg}"/></svg>`;
  if(k==='aparador')return `<svg viewBox="0 0 160 78" width="${w}" height="${h}" preserveAspectRatio="none" aria-hidden="true"><rect x="0" y="0" width="160" height="62" rx="3" fill="#8A6A4C"/><rect x="4" y="6" width="74" height="50" rx="2" fill="#977657"/><rect x="82" y="6" width="74" height="50" rx="2" fill="#977657"/><rect x="10" y="62" width="4" height="16" fill="${leg}"/><rect x="146" y="62" width="4" height="16" fill="${leg}"/></svg>`;
  if(k==='cama')return `<svg viewBox="0 0 160 105" width="${w}" height="${h}" preserveAspectRatio="none" aria-hidden="true"><rect x="0" y="0" width="160" height="105" rx="6" fill="#9C8C78"/><rect x="0" y="55" width="160" height="50" rx="4" fill="#E9E4DA"/><rect x="0" y="80" width="160" height="25" fill="#D6CEC0"/><rect x="14" y="42" width="58" height="22" rx="8" fill="#F4F1EA"/><rect x="88" y="42" width="58" height="22" rx="8" fill="#F4F1EA"/></svg>`;
  return '';
}
const narrow=()=>window.matchMedia('(max-width:900px)').matches;
function availW(){const p=stage.parentElement,cs=getComputedStyle(p);return p.clientWidth-parseFloat(cs.paddingLeft)-parseFloat(cs.paddingRight);}
function render(){
  if(!st.slots.length)return;
  const ext=bounds(), N=narrow(), maxH=Math.max(260,window.innerHeight*(N?0.44:0.68));
  let pxW=availW();
  stage.classList.toggle('photo',!!st.photo);
  const wi=$('wallimg'); wi.hidden=!st.photo;
  if(st.photo){
    let h=pxW*st.photo.h/st.photo.w;
    if(h>maxH){h=maxH;pxW=h*st.photo.w/st.photo.h;}
    stage.style.width=pxW+'px'; stage.style.marginInline='auto'; stage.style.height=h+'px';
    wi.style.backgroundImage=`url(${st.photo.src})`;
    const d=Math.abs(st.pins[1]-st.pins[0])*pxW;
    scale=st.calibCm>0?d/st.calibCm:pxW/300;
    cxPx=pxW/2+st.gx*scale; cyPx=h*0.4+st.gy*scale;
  }else{
    stage.style.width=''; stage.style.marginInline='';
    const F0=FURN[st.furn];
    let cf=st.furn==='none'?150:Math.max(F0.h+22+ext.h/2,145);
    cf=Math.min(cf,WALL_H-ext.h/2-8);
    const viewTop=N?Math.min(WALL_H,cf+ext.h/2+28):WALL_H, crop=N?48:0;
    let W=Math.max(150,Math.min(600,+st.wallW||320)); if(N)W=Math.min(W,Math.max(ext.w+40,160));
    const totalH=viewTop+FLOOR_CM-crop;
    scale=Math.min(pxW/W,maxH/totalH); stage.style.height=(totalH*scale)+'px';
    $('wall').style.background=WALLS[st.wall][0];
    const flo=$('floor'); flo.style.height=(FLOOR_CM*scale)+'px'; flo.style.bottom=(-crop*scale)+'px';
    const F=FURN[st.furn], fe=$('furnEl');
    fe.innerHTML=furnSVG(st.furn,F.w*scale,F.h*scale);
    fe.style.left=(pxW/2-F.w*scale/2)+'px'; fe.style.bottom=((FLOOR_CM-crop)*scale-2)+'px';
    cxPx=pxW/2+st.gx*scale; cyPx=(viewTop-cf)*scale+st.gy*scale;
  }
  const dark=!st.photo&&st.wall===4;
  slotsEl.innerHTML='';
  slotsEl.style.display=st.calibrating?'none':'';
  st.slots.forEach((s,i)=>{
    const d=dimsOf(s), it=s.item&&BYID[s.item];
    const el=document.createElement('div'); el.className='slot'+(it?'':' empty')+(i===st.active?' active':'');
    const w=d.w*scale,h=d.h*scale;
    el.style.width=w+'px';el.style.height=h+'px';
    el.style.left=(cxPx+(s.cx+s.dx)*scale-w/2)+'px'; el.style.top=(cyPx+(s.cy+s.dy)*scale-h/2)+'px';
    el.dataset.i=i; el.tabIndex=0; el.setAttribute('role','button');
    el.setAttribute('aria-label',it?`${it.t}, ${sizeLabel(s)} cm`:`Lugar ${i+1} vacío, elegir cuadro`);
    if(!it){el.textContent=w>50?'+ Elegir cuadro':'+';if(dark||st.photo){el.style.color='#fff';el.style.borderColor='rgba(255,255,255,.8)';el.style.background='rgba(0,0,0,.18)';}}
    else{
      probe(it);
      const fr=it.mdf?'SM':s.frame, F2=FRAMES[fr], b=it.mdf?0:Math.max(2,2.2*scale);
      if(it.mdf)el.style.boxShadow=`${scale*.9}px ${scale*.9}px 0 ${F2.c}, 0 ${scale*1.5}px ${scale*3.5}px rgba(0,0,0,.28)`;
      else{el.style.background=`linear-gradient(135deg,${F2.hi},${F2.c})`;el.style.boxShadow=`0 ${scale*.8}px ${scale*3.2}px rgba(0,0,0,.28)`;}
      const art=document.createElement('div');art.className='art';
      const u=imgURL(it,s.piece,Math.min(1200,Math.ceil(Math.max(w,h)*(window.devicePixelRatio||1)/100)*100));
      art.style.inset=b+'px'; if(u)art.style.backgroundImage=`url("${u}")`;
      if(!it.mdf)art.style.boxShadow='inset 0 0 3px rgba(0,0,0,.35)';
      if(s.margin){const m=Math.max(2,Math.min(d.w,d.h)*0.08*scale);art.style.inset=(b+m)+'px';const mat=document.createElement('div');mat.className='mat';mat.style.inset=b+'px';el.appendChild(mat);}
      el.appendChild(art);
      if(!it.mdf&&s.glass==='VC'){const g=document.createElement('div');g.className='glass';g.style.inset=b+'px';el.appendChild(g);}
    }
    const tg=document.createElement('div');tg.className='tag';tg.textContent=sizeLabel(s);if(dark||st.photo){tg.style.color='rgba(255,255,255,.95)';tg.style.textShadow='0 1px 3px rgba(0,0,0,.7)';}el.appendChild(tg);
    slotsEl.appendChild(el);
  });
  // medidas: si las etiquetas de cuadros vecinos se pisan, se muestra una sola debajo del set
  const tags=[...slotsEl.querySelectorAll('.tag')];
  let clash=false;
  for(let i=0;i<tags.length&&!clash;i++){const a=tags[i].getBoundingClientRect();for(let j=i+1;j<tags.length;j++){const b=tags[j].getBoundingClientRect();if(a.left<b.right+4&&b.left<a.right+4&&a.top<b.bottom&&b.top<a.bottom){clash=true;break;}}}
  if(clash){
    tags.forEach(t=>t.hidden=true);
    const cnt={};st.slots.forEach(s=>{const l=sizeLabel(s);cnt[l]=(cnt[l]||0)+1;});
    let bot=0,lft=1e9,rgt=-1e9;[...slotsEl.children].forEach(e=>{const t=parseFloat(e.style.top),l=parseFloat(e.style.left);bot=Math.max(bot,t+parseFloat(e.style.height));lft=Math.min(lft,l);rgt=Math.max(rgt,l+parseFloat(e.style.width));});
    const g=document.createElement('div');g.className='tag';g.style.left=((lft+rgt)/2)+'px';g.style.top=(bot+6)+'px';g.style.bottom='auto';
    g.textContent=Object.entries(cnt).map(([l,n])=>n>1?`${n} de ${l}`:l).join(' · ')+' cm';
    if(dark||st.photo){g.style.color='rgba(255,255,255,.95)';g.style.textShadow='0 1px 3px rgba(0,0,0,.7)';}
    slotsEl.appendChild(g);
  }
  renderPins(pxW);
  $('dims').textContent=`${Math.round(ext.w)} × ${Math.round(ext.h)} cm`;
  renderPanel(); renderSummary();
}
function bounds(){
  let x0=1e9,x1=-1e9,y0=1e9,y1=-1e9;
  st.slots.forEach(s=>{const d=dimsOf(s);x0=Math.min(x0,(s.cx||0)+s.dx-d.w/2);x1=Math.max(x1,(s.cx||0)+s.dx+d.w/2);y0=Math.min(y0,(s.cy||0)+s.dy-d.h/2);y1=Math.max(y1,(s.cy||0)+s.dy+d.h/2);});
  return{w:x1-x0,h:y1-y0};
}

/* ---------- medir la foto ---------- */
function renderPins(pxW){
  pinsEl.innerHTML='';
  if(!st.photo||!st.calibrating)return;
  const h=stage.clientHeight, y=st.pinY*h, a=st.pins[0]*pxW, b=st.pins[1]*pxW;
  const line=document.createElement('div');line.className='pinline';line.style.left=Math.min(a,b)+'px';line.style.width=Math.abs(b-a)+'px';line.style.top=y+'px';pinsEl.appendChild(line);
  const lab=document.createElement('div');lab.className='pinlabel';lab.style.left=((a+b)/2)+'px';lab.style.top=y+'px';
  lab.textContent=st.calibCm>0?`${st.calibCm} cm`:'¿cuántos cm?';pinsEl.appendChild(lab);
  [a,b].forEach((x,k)=>{const p=document.createElement('div');p.className='pin';p.style.left=x+'px';p.style.top=y+'px';p.dataset.k=k;p.setAttribute('aria-label',k?'Punto derecho':'Punto izquierdo');pinsEl.appendChild(p);});
}
let pinDrag=null;
pinsEl.addEventListener('pointerdown',e=>{const p=e.target.closest('.pin');if(!p)return;e.stopPropagation();pinDrag={k:+p.dataset.k};p.setPointerCapture(e.pointerId);});
pinsEl.addEventListener('pointermove',e=>{if(!pinDrag)return;const r=stage.getBoundingClientRect();
  st.pins[pinDrag.k]=Math.max(0,Math.min(1,(e.clientX-r.left)/r.width)); st.pinsMoved=true; st.pinY=Math.max(.05,Math.min(.95,(e.clientY-r.top)/r.height)); renderPins(r.width);});
pinsEl.addEventListener('pointerup',()=>{pinDrag=null;});
function startCalib(){st.calibrating=true;$('calib').hidden=false;$('calibCm').value=st.calibCm||'';render();$('calibCm').focus();}
$('calibCm').oninput=e=>{st.calibCm=+e.target.value||0;renderPins(stage.clientWidth);};
$('calibOk').onclick=()=>{
  const inp=$('calibCm'), v=+inp.value;
  if(!st.pinsMoved){inp.setCustomValidity('Primero arrastrá los dos puntos naranjas hasta los bordes de lo que mediste (por ejemplo, los dos costados de la pared).');inp.reportValidity();setTimeout(()=>inp.setCustomValidity(''),3000);return;}
  if(!v||v<20){inp.focus();inp.setCustomValidity('Escribí la medida en centímetros');inp.reportValidity();return;}
  inp.setCustomValidity('');
  st.calibCm=v; st.calibrating=false; $('calib').hidden=true; st.pinsMoved=true; st.gx=0; st.gy=0; render();
};

/* ---------- foto de la pared ---------- */
const photoSheet=$('photoSheet');
$('photoOpen').onclick=()=>{photoSheet.hidden=false;$('photoClose').focus();};
$('photoClose').onclick=()=>photoSheet.hidden=true;
photoSheet.addEventListener('click',e=>{if(e.target===photoSheet)photoSheet.hidden=true;});
$('photoFile').onchange=e=>{
  const f=e.target.files&&e.target.files[0]; if(!f)return;
  const url=URL.createObjectURL(f), im=new Image();
  im.onload=()=>{
    const k=Math.min(1,1800/Math.max(im.width,im.height)), c=document.createElement('canvas');
    c.width=Math.round(im.width*k); c.height=Math.round(im.height*k); c.getContext('2d').drawImage(im,0,0,c.width,c.height);
    st.photo={src:c.toDataURL('image/jpeg',.85),w:c.width,h:c.height}; URL.revokeObjectURL(url);
    st.pins=[.1,.9]; st.pinY=.8; st.calibCm=0; st.pinsMoved=false; photoSheet.hidden=true; syncWallUI(); startCalib();
  };
  im.src=url; e.target.value='';
};
$('recalib').onclick=startCalib;
$('photoOff').onclick=()=>{st.photo=null;st.calibrating=false;$('calib').hidden=true;st.gx=0;st.gy=0;syncWallUI();render();};
function syncWallUI(){
  $('sampleWall').hidden=!!st.photo; $('photoWall').hidden=!st.photo;
  $('photoState').textContent=st.photo?'Estás viendo tu pared. Podés cambiar la foto cuando quieras.':'Estás viendo una pared de ejemplo. Subí una foto de la tuya para verlo en tu casa.';
  $('photoOpen').textContent=st.photo?'Cambiar foto':'Usar mi pared';
}

/* ---------- arrastre: un cuadro o toda la composición ---------- */
let drag=null, moveMode=false;
const coarse=()=>window.matchMedia('(pointer:coarse)').matches;
const moveBtn=$('moveBtn');
function setMove(on){moveMode=on;stage.classList.toggle('movemode',on);moveBtn.setAttribute('aria-pressed',on);moveBtn.textContent=on?'✓ Listo, fijar':'✥ Mover cuadros';}
moveBtn.addEventListener('pointerdown',e=>e.stopPropagation());
moveBtn.onclick=()=>setMove(!moveMode);
stage.addEventListener('pointerdown',e=>{
  if(st.calibrating||e.target.closest('.pin')||e.target.closest('#moveBtn'))return;
  const canDrag=!(e.pointerType==='touch'||coarse())||moveMode;
  const el=e.target.closest('.slot');
  if(el){const i=+el.dataset.i;drag={mode:'one',i,x:e.clientX,y:e.clientY,dx:st.slots[i].dx,dy:st.slots[i].dy,moved:false,el,canDrag};}
  else drag={mode:'all',x:e.clientX,y:e.clientY,gx:st.gx,gy:st.gy,moved:false,canDrag};
  if(canDrag)stage.setPointerCapture(e.pointerId);
});
stage.addEventListener('pointermove',e=>{
  if(!drag)return; const mx=e.clientX-drag.x,my=e.clientY-drag.y;
  if(!drag.moved&&Math.hypot(mx,my)<6)return; drag.moved=true;
  if(!drag.canDrag)return;
  if(drag.mode==='one'){drag.el.classList.add('dragging');const s=st.slots[drag.i];s.dx=drag.dx+mx/scale;s.dy=drag.dy+my/scale;drag.el.style.transform=`translate(${mx}px,${my}px)`;}
  else{stage.classList.add('groupdrag');slotsEl.style.transform=`translate(${mx}px,${my}px)`;st.gx=drag.gx+mx/scale;st.gy=drag.gy+my/scale;}
});
stage.addEventListener('pointercancel',()=>{if(drag&&drag.canDrag&&drag.moved)render();drag=null;stage.classList.remove('groupdrag');slotsEl.style.transform='';});
stage.addEventListener('pointerup',()=>{
  if(!drag)return; const d=drag; drag=null; stage.classList.remove('groupdrag'); slotsEl.style.transform='';
  if(d.moved){if(d.canDrag)render();return;}
  if(d.mode==='one'){st.active=d.i; setTab('cuadro'); hideTapHint(); if(!st.slots[d.i].item)openPicker(); else {render(); if(narrow())scrollToPanel();}}
});
function hideTapHint(){$('tapHint').hidden=true;}
function scrollToPanel(){const p=root.querySelector('.panel');const sc=root.querySelector('.stagecol');const y=p.getBoundingClientRect().top+window.scrollY-sc.offsetHeight-8;window.scrollTo({top:Math.max(0,y),behavior:'smooth'});}
slotsEl.addEventListener('keydown',e=>{
  const el=e.target.closest('.slot'); if(!el)return;
  if(e.key==='Enter'||e.key===' '){e.preventDefault();st.active=+el.dataset.i;if(!st.slots[st.active].item)openPicker();else render();}
});
$('reflow').onclick=()=>{st.gx=0;st.gy=0;flow();};

/* ---------- sugerencias (Combínalos) ---------- */
function combos(){
  const cur=st.slots[st.active]&&st.slots[st.active].item;
  const others=st.slots.map(s=>s.item).filter(Boolean);
  const order=[cur,...others.filter(x=>x!==cur)].filter(Boolean);
  const out=[];
  (cur?[cur]:others).forEach(id=>{(SUG&&SUG[id]||[]).concat(BYID[id].p||[]).forEach(p=>{if(!out.includes(p)&&!others.includes(p)&&BYID[p])out.push(p);});});
  return out;
}

/* ---------- panel ---------- */
function renderStatic(){
  const w=$('walls');
  w.innerHTML=WALLS.map((c,i)=>`<button type="button" class="wallsw" style="background:${c[0]}" aria-label="${c[1]}" title="${c[1]}" aria-pressed="${i===st.wall}" data-w="${i}"></button>`).join('');
  w.onclick=e=>{const b=e.target.closest('[data-w]');if(!b)return;st.wall=+b.dataset.w;renderStatic();render();};
  const l=$('layouts'), n=st.slots.length;
  l.innerHTML=`<div class="stepper"><button type="button" class="stepbtn" data-d="-1" aria-label="Quitar un cuadro" ${n<=1?'disabled':''}>−</button>
    <div class="stepval"><b>${n}</b><span>${n===1?'cuadro':'cuadros'}</span></div>
    <button type="button" class="stepbtn" data-d="1" aria-label="Agregar un cuadro" ${n>=MAXN?'disabled':''}>+</button></div>
    ${arrOptions(n).length>1?`<div class="field">Cómo acomodarlos<div class="arrs">${arrOptions(n).map(k=>`<button type="button" class="lay" data-a="${k}" aria-pressed="${k===st.arr}">${arrIcon(k,n)}${ARR[k]}</button>`).join('')}</div></div>`:''}
    <p class="hint">Se quitan desde el último. Si elegís un set, suma los cuadros que necesite.</p>`;
  l.onclick=e=>{const d=e.target.closest('[data-d]');if(d){setCount(st.slots.length+(+d.dataset.d));return;}
    const a=e.target.closest('[data-a]');if(a){st.arr=a.dataset.a;st.gx=0;st.gy=0;renderStatic();flow();}};
}
const panel=root.querySelector('.panel');
function setTab(t){panel.dataset.tab=t;panel.querySelectorAll('[data-tab]').forEach(b=>{if(b.tagName==='BUTTON')b.setAttribute('aria-selected',b.dataset.tab===t);});}
panel.querySelector('.tabbar').onclick=e=>{const b=e.target.closest('button[data-tab]');if(b)setTab(b.dataset.tab);};
setTab('cuadro');
function groupSlots(s){return s.group?st.slots.filter(x=>x.group===s.group):[s];}
function renderPanel(){
  const s=st.slots[st.active], body=$('slotbody');
  if(!s){body.innerHTML='';return;}
  const it=s.item&&BYID[s.item];
  const sug=combos().slice(0,12);
  const sugHTML=sug.length?`<div class="sec" style="gap:6px"><div class="suggHead"><span class="selmeta"><b style="color:var(--ink)">${it?'Combinan con este':'Combinan con tu pared'}</b></span><button class="linkbtn" type="button" data-more>Ver todos</button></div>
    <div class="sugg" id="sugg">${sug.map(id=>`<button type="button" data-id="${id}" title="${BYID[id].t}" aria-label="Poner ${BYID[id].t}">${thumbs(BYID[id],200)}</button>`).join('')}</div></div>`:'';
  if(!it){
    body.innerHTML=`<p class="hint">El lugar ${st.active+1} está vacío.</p>${sugHTML}<div class="row"><button class="chip" type="button" id="pick">Elegir diseño</button></div>`;
    $('pick').onclick=openPicker; bindSugg(body); hydrate(body); return;
  }
  const sizes=it.sizes;
  const setTxt=it.n>1?`Pieza ${'ABC'[s.piece]} de un set x${it.n}`:'';
  const bestTxt=it.best?`Top ${it.best} en ventas`:'';
  body.innerHTML=`
   <div class="sel"><div class="selthumb">${oneThumb(it,s.piece,200)}</div>
    <div><div class="selname">${it.t}</div><div class="selmeta">${[setTxt,bestTxt].filter(Boolean).join(' · ')}</div>
    <div class="row" style="margin-top:6px"><button class="linkbtn" type="button" id="chg">Cambiar</button><a class="linkbtn" href="${ROOT}products/${it.h}" target="_blank" rel="noopener">Ver en la tienda ↗</a><button class="linkbtn" type="button" id="rm">Quitar</button></div></div></div>
   ${sugHTML}
   <div class="field">Medida (cm)<div class="row" id="szs">${sizes.map(z=>`<button type="button" class="chip" data-s="${z}" aria-pressed="${z===s.size}">${z.toLowerCase()}</button>`).join('')}</div><button class="allbtn" type="button" id="allSize">↳ Usar esta medida en todos los cuadros</button></div>
   ${it.mdf?`<p class="hint">Mural sin marco: placa de MDF impresa a sangre.</p>`:`
   <div class="field">Marco<div class="row" id="frs">${['NAT','NEG','NOG'].map(f=>`<button type="button" class="chip" data-f="${f}" aria-pressed="${f===s.frame}"><span class="dot" style="background:${FRAMES[f].c}"></span>${FRAMES[f].n}</button>`).join('')}</div><button class="allbtn" type="button" id="allFrame">↳ Usar este marco en todos los cuadros</button></div>
   <div class="field">Vidrio<div class="row" id="gls"><button type="button" class="chip" data-g="SV" aria-pressed="${s.glass==='SV'}">Sin vidrio</button><button type="button" class="chip" data-g="VC" aria-pressed="${s.glass==='VC'}">Con vidrio</button></div></div>`}
   <div class="field">Margen blanco<div class="row" id="mgs"><button type="button" class="chip" data-m="0" aria-pressed="${!s.margin}">Sin margen</button><button type="button" class="chip" data-m="1" aria-pressed="${!!s.margin}">Con margen blanco</button></div></div>
   ${it.n>1?`<p class="hint">Es un set: la medida y el marco cambian en las ${it.n} piezas juntas.</p>`:''}
   ${variantOf(s)?'':'<p class="note">Esta combinación no está disponible. Probá otra medida o marco.</p>'}
   ${receipt()}
   `;
  const apply=fn=>{groupSlots(s).forEach(fn);flow();};
  body.querySelector('#szs').onclick=e=>{const b=e.target.closest('[data-s]');if(b)apply(x=>x.size=b.dataset.s);};
  const frs=body.querySelector('#frs'); if(frs)frs.onclick=e=>{const b=e.target.closest('[data-f]');if(b)apply(x=>x.frame=b.dataset.f);};
  body.querySelector('#mgs').onclick=e=>{const b=e.target.closest('[data-m]');if(b)apply(x=>x.margin=b.dataset.m==='1');};
  const gls=body.querySelector('#gls'); if(gls)gls.onclick=e=>{const b=e.target.closest('[data-g]');if(b)apply(x=>x.glass=b.dataset.g);};
  body.querySelector('#chg').onclick=openPicker;
  body.querySelector('#rm').onclick=()=>{groupSlots(s).forEach(x=>{x.item=null;x.group=null;x.piece=0;});render();};
  body.querySelector('#allSize').onclick=()=>{st.slots.forEach(x=>{if(!x.item)return;if(BYID[x.item].sizes.includes(s.size))x.size=s.size;});flow();};
  const af=body.querySelector('#allFrame'); if(af)af.onclick=()=>{st.slots.forEach(x=>{if(!x.item||BYID[x.item].mdf)return;x.frame=s.frame;x.glass=s.glass;});flow();};
  bindSugg(body); hydrate(body);
  const rc=body.querySelector('.receipt ul'); if(rc)rc.onclick=e=>{const li=e.target.closest('[data-i]');if(!li)return;st.active=+li.dataset.i;if(!st.slots[st.active].item)openPicker();render();};
}
function bindSugg(body){
  const sg=body.querySelector('#sugg'); if(sg)sg.onclick=e=>{const b=e.target.closest('[data-id]');if(b)choose(b.dataset.id);};
  const m=body.querySelector('[data-more]'); if(m)m.onclick=()=>openPicker();
}
function variantOf(s){const it=BYID[s.item];const key=it.mdf?s.size:`${s.size}|${s.glass}|${s.frame}`;return it.v[key];}

/* ---------- resumen y carrito ---------- */
function cartLines(){
  const lines=[],seen={};
  st.slots.forEach(s=>{if(!s.item)return; if(s.group){if(seen[s.group])return;seen[s.group]=1;}
    const it=BYID[s.item],v=variantOf(s); if(!v)return;
    lines.push({id:v[0],price:v[1],name:it.t,size:sizeLabel(s),n:it.n,margin:!!s.margin,horiz:orientOf(s)==='h'});});
  return lines;
}
function receipt(){
  const rows=[],seen={}; let k=0;
  st.slots.forEach((s,i)=>{
    if(s.group){if(seen[s.group])return;seen[s.group]=1;}
    const n=s.item?BYID[s.item].n:1, from=k+1; k+=n;
    const num=n>1?`Cuadros ${from} a ${k}`:`Cuadro ${from}`;
    const sel=st.slots[st.active]&&(i===st.active||(s.group&&st.slots[st.active].group===s.group));
    if(!s.item){rows.push(`<li class="rc empty${sel?' sel':''}" data-i="${i}"><span><b>${num}</b><small>Lugar vacío · tocá para elegir</small></span><span>—</span></li>`);return;}
    const it=BYID[s.item], v=variantOf(s);
    const det=(it.mdf?`${sizeLabel(s)} · sin marco`:`${sizeLabel(s)} · marco ${FRAMES[s.frame].n.toLowerCase()}${s.glass==='VC'?' · con vidrio':''}`)+(s.margin?' · margen blanco':'');
    rows.push(`<li class="rc${sel?' sel':''}" data-i="${i}"><span><b>${num}${n>1?` (set x${n})`:''}</b><small>${it.t}</small><small>${det}</small></span><span>${v?fmt(v[1]):'—'}</span></li>`);
  });
  const T=totals();
  return `<div class="receipt"><div class="rchead">Tu set: ${T.pieces} ${T.pieces===1?'cuadro':'cuadros'}</div>
    <ul>${rows.join('')}</ul>
    ${T.disc>0?`<div class="rcline"><span>${CFG.discountLabel}</span><span>−${fmt(T.disc)}</span></div>`:''}
    <div class="rctotal"><span>Total${T.disc>0?' estimado':''}</span><b>${fmt(T.total)}</b></div>${T.total>0?`<div class="rcline" style="justify-content:flex-end"><span>12 cuotas de ${fmt(T.total/12)}</span></div>`:''}</div>`;
}
function totals(){const L=cartLines(),list=L.reduce((a,l)=>a+l.price,0),pct=(+CFG.discountPct||0)/100,
  disc=L.map(l=>l.price).sort((a,b)=>b-a).slice(1).reduce((a,p)=>a+p*pct,0);
  return{list,disc,total:list-disc,pieces:st.slots.filter(s=>s.item).length};}
function renderSummary(){
  const L=cartLines(), T=totals();
  $('bTotal').textContent=fmt(T.total);let cq=$('bCuotas');if(!cq){cq=document.createElement('span');cq.id='bCuotas';cq.style.cssText='display:block;font-size:12px;color:var(--muted);margin-top:2px';$('bTotal').parentElement.appendChild(cq);}cq.textContent=T.total>0?`12 cuotas de ${fmt(T.total/12)}`:'';
  const pieces=T.pieces, empty=st.slots.length-pieces;
  $('bCount').textContent=`${pieces} ${pieces===1?'cuadro':'cuadros'}`+(empty?` · ${empty} ${empty===1?'lugar vacío':'lugares vacíos'}`:'');
  const buy=$('buy'); buy.disabled=!L.length||buying;
}
let buying=false;
$('buy').onclick=async()=>{
  const L=cartLines(); if(!L.length||buying)return;
  buying=true; const btn=$('buy'), txt=btn.textContent; btn.textContent='Agregando…'; btn.disabled=true;
  try{
    // cada cuadro va como línea del carrito; el margen blanco y la orientación quedan anotados en el pedido
    const items=L.map(l=>{const pr={'_Armado en':'Simulador de paredes'};
      if(l.margin)pr['Margen blanco']='Sí';
      if(l.horiz)pr['Orientación']='Horizontal';
      return{id:l.id,quantity:1,properties:pr};});
    const r=await fetch(ROOT+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items})});
    if(!r.ok){const j=await r.json().catch(()=>({}));throw new Error(j.description||'No se pudo agregar');}
    const mg=L.filter(l=>l.margin), hz=L.filter(l=>l.horiz);
    const add='Armado en el simulador de paredes.'+(mg.length?' IMPRIMIR CON MARGEN BLANCO: '+mg.map(l=>`${l.name} (${l.size})`).join('; ')+'.':'')+(hz.length?' HORIZONTAL: '+hz.map(l=>l.name).join('; ')+'.':'');
    const cart=await fetchJSON(ROOT+'cart.js');
    const note=cart.note&&cart.note.includes(add)?cart.note:[cart.note,add].filter(Boolean).join('\n');
    await fetch(ROOT+'cart/update.js',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({note})});
    window.location.href=ROOT+'cart';
  }catch(e){
    btn.textContent=txt; buying=false; btn.disabled=false;
    alertMsg('No pudimos agregar el set al carrito ('+e.message+'). Probá de nuevo o escribinos por WhatsApp.');
  }
};
function alertMsg(t){const n=$('toast');n.textContent=t;n.hidden=false;clearTimeout(alertMsg._t);alertMsg._t=setTimeout(()=>n.hidden=true,6000);}

/* ---------- selector de diseños ---------- */
const sheet=$('sheet'); let filt=null, limit=48, query='';
function tabs(){
  const t=[];
  if(st.viewed.length)t.push('Estabas viendo');
  if(combos().length)t.push('Combinan');
  if(BEST.length)t.push('Más vendidos');
  CFG.tabs.forEach(x=>t.push(x.title));
  if(CAT.some(c=>c.n>1))t.push('Sets');
  if(CAT.some(c=>c.mdf))t.push('Sin marco');
  t.push('Todos');
  return t;
}
function openPicker(){filt=tabs()[0];query='';$('search').value='';limit=48;sheet.hidden=false;renderGrid();$('closeSheet').focus();}
function closePicker(){sheet.hidden=true;}
$('closeSheet').onclick=closePicker;
sheet.addEventListener('click',e=>{if(e.target===sheet)closePicker();});
document.addEventListener('keydown',e=>{if(e.key==='Escape'){closePicker();photoSheet.hidden=true;}});
$('search').oninput=e=>{query=e.target.value.trim().toLowerCase();limit=48;renderGrid();};
function fromPrice(it){const p=Object.values(it.v).map(v=>v[1]);return p.length?Math.min(...p):0;}
const norm=s=>s.toLowerCase().normalize('NFD').replace(/[\u0300-\u036f]/g,'');
function itemsFor(f){
  if(f==='Estabas viendo')return st.viewed.map(id=>BYID[id]);
  if(f==='Combinan')return combos().map(id=>BYID[id]);
  if(f==='Más vendidos')return BEST;
  if(f==='Sets')return CAT.filter(c=>c.n>1);
  if(f==='Sin marco')return CAT.filter(c=>c.mdf);
  if(f==='Todos')return CAT;
  const tab=CFG.tabs.find(x=>x.title===f); if(!tab)return CAT;
  if(!TABS[f]){TABS[f]='loading';loadCollection(tab.handle,'simu-lista').then(list=>{TABS[f]=list.map(p=>p.h).filter(h=>BYID[h]);if(filt===f&&!sheet.hidden)renderGrid();}).catch(()=>{TABS[f]=[];});}
  return Array.isArray(TABS[f])?TABS[f].map(h=>BYID[h]):null;
}
function renderGrid(){
  const T=tabs(); if(!T.includes(filt))filt=T[0];
  const fl=$('filters');
  fl.innerHTML=T.map(c=>`<button type="button" class="chip" data-c="${c}" aria-pressed="${c===filt&&!query}">${c}</button>`).join('');
  fl.onclick=e=>{const b=e.target.closest('[data-c]');if(b){filt=b.dataset.c;query='';$('search').value='';limit=48;renderGrid();}};
  let items=query?CAT.filter(c=>norm(c.t).includes(norm(query))):itemsFor(filt);
  const cur=st.slots[st.active]&&st.slots[st.active].item;
  $('sheetTitle').textContent=!query&&filt==='Combinan'&&cur?`Combinan con ${BYID[cur].t}`:'Elegí un diseño';
  const g=$('grid');
  if(items===null){g.innerHTML='<p class="hint">Cargando diseños…</p>';return;}
  if(!items.length){g.innerHTML=`<p class="hint">${query?'No encontramos diseños con ese nombre.':'Todavía no hay diseños en esta pestaña.'}</p>`;return;}
  const shown=items.slice(0,limit);
  g.innerHTML=shown.map(it=>`<button type="button" class="card" data-id="${it.id}">
    <div class="pic">${thumbs(it,360)}</div>
    ${it.n>1?`<span class="badge">Set x${it.n}${it.mdf?' · sin marco':''}</span>`:it.mdf?'<span class="badge">Sin marco</span>':it.best&&filt!=='Más vendidos'?'<span class="badge">Más vendido</span>':''}
    <b>${it.t}</b><span>desde ${fmt(fromPrice(it))}</span></button>`).join('')
    +(items.length>limit?`<div class="more"><button type="button" class="chip" id="moreBtn">Ver más diseños (${items.length-limit})</button></div>`:'');
  hydrate(g);
  g.onclick=e=>{if(e.target.closest('#moreBtn')){limit+=48;const y=g.scrollTop;renderGrid();g.scrollTop=y;return;}
    const b=e.target.closest('[data-id]');if(b){choose(b.dataset.id);closePicker();}};
  if(limit===48)g.scrollTop=0;
}
function fitSize(it,size,fallback){return it.sizes.includes(size)?size:(it.sizes.includes(fallback)?fallback:it.sizes[0]);}
function choose(id){
  const it=BYID[id]; const s=st.slots[st.active];
  if(s.group)groupSlots(s).forEach(x=>{x.item=null;x.group=null;x.piece=0;});
  if(it.n===1){
    s.item=id;s.piece=0;s.group=null;
    s.size=fitSize(it,s.size,'30X40');
    if(it.mdf)s.glass='SV';
  }else{
    const g='g'+(st.nextGroup++), i=st.active;
    const base=fitSize(it,s.size,it.mdf?'30X40':'40X50');
    for(let k=0;k<it.n;k++){
      let t=st.slots[i+k]; if(!t){t=mkSlot(base);st.slots.push(t);}
      if(t.group&&t.group!==g)groupSlots(t).forEach(x=>{x.item=null;x.group=null;x.piece=0;});
      Object.assign(t,{item:id,piece:k,group:g,size:base,frame:s.frame||'NAT',glass:it.mdf?'SV':s.glass,margin:s.margin});
    }
    renderStatic();
  }
  flow();
}

/* ---------- sugerencias: sumar cuadros que combinan (solo si llegó desde un cuadro individual) ---------- */
let SUG=null;
(function(){try{const s=document.querySelector('script[src*="arma-tu-pared"]');if(!s)return;const u=s.src.split('?')[0].replace(/arma-tu-pared(\.min)?\.js$/,'combinalos-sug.json');fetch(u).then(r=>r.ok?r.json():null).then(j=>{if(!j)return;const m={};j.s.forEach((a,i)=>{m[j.h[i]]=a.map(k=>j.h[k]);});SUG=m;try{renderSugg();}catch(e){}}).catch(()=>{});}catch(e){}})();
function suggestions(){
  const f=BYID[st.from]; if(!f)return [];
  // primero los que combinan por color y estilo (calculados de las imágenes)
  if(SUG&&SUG[f.id]){const u2=new Set(st.slots.map(s=>s.item).filter(Boolean));const l=SUG[f.id].map(h=>BYID[h]).filter(c=>c&&c.n===1&&!u2.has(c.id));if(l.length>=3)return l.slice(0,10);}
  const used=new Set(st.slots.map(s=>s.item).filter(Boolean));
  let pool=f.p.map(h=>BYID[h]).filter(c=>c&&c.n===1&&c.mdf===f.mdf);
  if(pool.length<6)pool=pool.concat(BEST.filter(c=>c.n===1&&c.mdf===f.mdf));
  return [...new Set(pool)].filter(c=>!used.has(c.id)).slice(0,10);
}
function renderSugg(){
  let box=root.getElementById('sumaWrap');
  const bar=root.querySelector('.stagebar');
  if(!bar)return;
  if(!box){
    const css=document.createElement('style');
    css.textContent=`.suma{margin-top:12px;border:1px solid var(--line);border-radius:14px;padding:12px 14px;background:var(--panel)}
.suma b{display:block;font-size:14px;margin-bottom:2px}.suma p{margin:0 0 10px;font-size:12px;color:var(--muted)}
.sumarow{display:flex;gap:10px;overflow-x:auto;padding-bottom:4px;scrollbar-width:thin}
.sumabtn{flex:0 0 auto;width:84px;border:1px solid var(--line);border-radius:10px;background:var(--ground);padding:6px;cursor:pointer;position:relative;font:inherit;color:var(--ink)}
.sumabtn img{display:block;width:100%;aspect-ratio:4/5;object-fit:cover;border-radius:6px;background:var(--soft)}
.sumabtn span{position:absolute;right:4px;top:4px;width:24px;height:24px;border-radius:50%;background:var(--accent);color:var(--accent-ink);font:600 16px/24px var(--atp-body);text-align:center}
.sumabtn:focus-visible{outline:2px solid var(--accent);outline-offset:2px}`;
    root.appendChild(css);
    box=document.createElement('div');box.className='suma';box.id='sumaWrap';
    bar.insertAdjacentElement('afterend',box);
  }
  const list=st.entry==='product1'&&st.slots.length<MAXN?suggestions():[];
  if(!list.length){box.hidden=true;return;}
  box.hidden=false;
  box.innerHTML=`<b>Sumá cuadros que combinan</b><p>Tocá uno para agregarlo a tu pared. Desde el 2º cuadro tenés descuento.</p>
  <div class="sumarow">${list.map(c=>`<button type="button" class="sumabtn" data-id="${c.id}" aria-label="Sumar ${c.t}">${oneThumb(c,0,200)}<span aria-hidden="true">+</span></button>`).join('')}</div>`;
  hydrate(box);
  box.querySelectorAll('.sumabtn').forEach(b=>b.onclick=()=>{
    const n=st.slots.length; setCount(n+1); st.active=n; choose(b.dataset.id); renderSugg();
  });
}

/* ---------- inicio ---------- */
// Cómo llegó: desde un SET de Combínalos, desde una ficha, desde un anuncio de Meta o directo
function entryMode(){
  const q=new URLSearchParams(location.search);
  if(q.get('set'))return 'set';
  if(q.get('desde'))return 'product';
  if(q.get('fbclid')||/^(fb|facebook|ig|instagram|meta)/i.test(q.get('utm_source')||''))return 'meta';
  return 'auto';
}
function readViewed(mode){
  const q=new URLSearchParams(location.search), out=[];
  (q.get('desde')||'').split(',').forEach(h=>h&&out.push(h));
  // si viene de un anuncio de Meta arranca con los más vendidos, no con lo que vio antes
  if(mode!=='meta')try{JSON.parse(localStorage.getItem('thd_vistos')||'[]').forEach(h=>out.push(h));}catch(e){}
  return [...new Set(out)].filter(h=>BYID[h]).slice(0,8);
}
// Pone una lista de productos en la pared, cada set con todas sus piezas
function placeItems(list){
  const items=[];let total=0;
  list.forEach(c=>{if(c&&total+c.n<=8){items.push(c);total+=c.n;}});
  if(!items.length)return false;
  const size=total<=3?'40X50':'30X40';
  initSlots(total,size);
  let i=0;
  items.forEach(it=>{
    const base=fitSize(it,size,'30X40'), g=it.n>1?'g'+(st.nextGroup++):null;
    for(let k=0;k<it.n;k++){Object.assign(st.slots[i],{item:it.id,piece:k,group:g,size:base,glass:'SV'});i++;}
  });
  st.viewed=items.map(c=>c.id); st.active=0; renderStatic(); flow();
  return true;
}
// Distribuciones especiales para algunos SET (medidas en cm; x,y = centro de cada cuadro)
const INICIO='set-x2-cuadros-decorativos-sol-y-luna-ii';
const SET_LAYOUTS={
  // anuncio "De lo guardé en Pinterest a tenerlo en tu pared"
  set2618:[
    {h:'cuadro-decorativo-trendy-mujer-rayas-rojo-rosa-marco-natural',size:'40X50',x:-41,y:-4},
    {h:'cuadro-decorativo-trendy-more-amor-por-favor-crema-marco-natural',size:'30X40',x:0,y:-23},
    {h:'cuadro-decorativo-trendy-dalmata-collar-perlas-crema-marco-natural',size:'30X40',x:0,y:23},
    {h:'cuadro-decorativo-trendy-aloe-maceta-roja-crema-marco-natural',size:'40X50',x:41,y:-2}
  ]
};
// Arranca con todos los cuadros de un SET de Combínalos ya puestos en la pared
function startSet(code){
  const lay=SET_LAYOUTS[code];
  if(lay&&lay.every(q=>BYID[q.h])){
    initSlots(lay.length,'40X50');
    lay.forEach((q,i)=>Object.assign(st.slots[i],{item:q.h,piece:0,group:null,size:fitSize(BYID[q.h],q.size,'40X50'),glass:'SV'}));
    st.custom=lay.map(q=>({x:q.x,y:q.y})); st.arr='custom';
    st.viewed=lay.map(q=>q.h); st.active=0; renderStatic(); flow();
    return true;
  }
  return placeItems(CAT.filter(c=>c.sets.includes(code)).sort((a,b)=>a.n-b.n));
}
// Si viene de una ficha con una variante elegida (?v=id), usa esa medida, marco y vidrio
function aplicarVariante(){
  const q=new URLSearchParams(location.search), vid=q.get('v'), h=(q.get('desde')||'').split(',')[0];
  const it=BYID[h]; if(!vid||!it)return;
  const e=Object.entries(it.v).find(([k,x])=>String(x[0])===String(vid)); if(!e)return;
  const [size,gl,fr]=e[0].split('|');
  st.slots.filter(s=>s.item===h).forEach(s=>{s.size=size;if(gl)s.glass=gl;if(fr)s.frame=fr;});
  renderStatic(); flow();
}
// después de cada renderStatic actualiza las sugerencias
const _renderStatic0=renderStatic; renderStatic=function(){_renderStatic0();if(st.from)try{renderSugg();}catch(e){}};
function start(){ _start(); try{aplicarVariante();}catch(e){console.warn(e);} try{renderSugg();}catch(e){console.warn(e);} }
function _start(){
  const mode=entryMode();
  st.gx=0; st.gy=0;
  if(mode==='set'&&startSet(new URLSearchParams(location.search).get('set').toLowerCase())){st.entry='set';return;}
  st.viewed=readViewed(mode); st.entry=st.viewed.length?'product':(mode==='meta'?'meta':'direct');
  // viene de una ficha: pone solo ese cuadro (o el set x2 / x3 completo)
  const first=mode==='product'?BYID[(new URLSearchParams(location.search).get('desde')||'').split(',')[0]]:null;
  if(first&&placeItems([first])){st.entry=first.n>1?'productset':'product1';st.from=first.id;st.viewed=readViewed(mode);return;}
  // por ahora, si no viene de un producto ni de un SET, arranca con Sol y Luna II
  if(mode!=='product'&&BYID[INICIO]&&placeItems([BYID[INICIO]])){st.slots.forEach(s=>s.size=fitSize(BYID[INICIO],'50X70',s.size));st.entry='inicio';renderStatic();flow();return;}
  initSlots(3,'40X50');
  // viene de un producto: arranca con lo que estaba viendo y completa con lo que combina; si no, con los más vendidos
  let pool=st.entry==='product'?st.viewed.map(h=>BYID[h]):[];
  if(pool.length<3){const extra=[];pool.forEach(c=>c.p.forEach(o=>{if(!extra.includes(o))extra.push(o);}));
    const mdf=pool[0]?pool[0].mdf:false;
    pool=pool.concat(extra.map(h=>BYID[h]).filter(c=>c.mdf===mdf),BEST.filter(c=>c.mdf===mdf));}
  pool=[...new Set(pool)];
  let k=0; pool.filter(c=>c.n===1).forEach(c=>{if(k<3){st.slots[k].item=c.id;st.slots[k].size=fitSize(c,'40X50','30X40');if(c.mdf)st.slots[k].glass='SV';k++;}});
  if(!k)CAT.filter(c=>c.n===1&&!c.mdf).slice(0,3).forEach((c,i)=>{st.slots[i].item=c.id;st.slots[i].size=fitSize(c,'40X50','30X40');});
  st.active=Math.min(1,st.slots.length-1); renderStatic(); flow();
}
// agrega productos al catálogo (sin repetir) y recalcula qué combina con qué
function addProducts(list){
  let n=0;
  list.forEach(p=>{if(!p||!p.s||BYID[p.h])return;const it=parseProduct(p);if(!Object.keys(it.v).length)return;CAT.push(it);BYID[it.id]=it;n++;});
  if(n){
    // Combínalos: los productos que comparten una etiqueta SET combinan entre sí
    const bySet={}; CAT.forEach(c=>c.sets.forEach(t=>(bySet[t]=bySet[t]||[]).push(c.id)));
    CAT.forEach(c=>{const q=[];c.sets.forEach(t=>bySet[t].forEach(o=>{if(o!==c.id&&!q.includes(o))q.push(o);}));c.p=q;});
  }
  return n;
}
// un producto suelto, rápido (lo que la persona estaba viendo)
async function fetchProd(h){
  try{
    const r=await fetch(`${ROOT}products/${encodeURIComponent(h)}.js`,{credentials:'same-origin'}); if(!r.ok)return null;
    const p=await r.json(), tags=(p.tags||[]).map(t=>String(t).toLowerCase());
    return {h:p.handle,t:p.title,s:tags.includes('simulador')?1:0,k:(p.variants[0]||{}).sku||'',
      g:tags.filter(t=>t.startsWith('set')||t.startsWith('simu-')),v:p.variants.map(v=>[v.id,v.title,v.price])};
  }catch(e){return null;}
}
async function firstPage(handle,view){try{return (await fetchJSON(`${ROOT}collections/${handle}?view=${view}&page=1`)).p;}catch(e){return [];}}
let FULL=false;
async function boot(){
  try{
    // 1) lo mínimo para arrancar: más vendidos, lo que estaba viendo y el SET si viene de uno
    const q=new URLSearchParams(location.search), mode=entryMode();
    let seen=[];if(mode!=='meta')try{seen=JSON.parse(localStorage.getItem('thd_vistos')||'[]');}catch(e){}
    const handles=[...new Set([...(q.get('set')||q.get('desde')?[]:[INICIO]),...((q.get('set')&&SET_LAYOUTS[q.get('set').toLowerCase()])||[]).map(x=>x.h),...(q.get('desde')||'').split(','),...seen,...(CFG.start||[])].filter(Boolean))].slice(0,12);
    const [top,setList,...singles]=await Promise.all([
      CFG.best?firstPage(CFG.best,'simu-top'):Promise.resolve([]),
      q.get('set')?firstPage(q.get('set').toLowerCase(),'simu'):Promise.resolve([]),
      ...handles.map(fetchProd)
    ]);
    addProducts(top); addProducts(setList); addProducts(singles);
    BEST=top.map(p=>BYID[p.h]).filter(Boolean).slice(0,CFG.bestCount||32);
    BEST.forEach((c,i)=>c.best=i+1);
    if(!CAT.length){await loadAll();}
    if(!CAT.length)throw new Error('sin productos');
    $('loading').hidden=true;
    start();
    let tour=false; try{tour=localStorage.getItem('thd_tour')==='1';}catch(e){}
    if(!tour)setTimeout(()=>showStep(0),700);
    // 2) el resto del catálogo, de fondo, mientras la persona ya usa el simulador
    if(!FULL)loadAll().then(()=>{renderStatic();if(!sheet.hidden)renderGrid();}).catch(e=>console.warn('[Armá tu pared]',e));
  }catch(e){
    console.error('[Armá tu pared]',e);
    $('loading').textContent='No pudimos cargar los diseños. Recargá la página para intentar de nuevo.';
  }
}
async function loadAll(){const all=await loadCollection(CFG.catalog,'simu');addProducts(all);FULL=true;}

$('wallW').oninput=e=>{st.wallW=+e.target.value||320;render();};
$('furn').onchange=e=>{st.furn=e.target.value;render();};
let rt;window.addEventListener('resize',()=>{clearTimeout(rt);rt=setTimeout(render,80);});

/* ---------- tutorial paso a paso ---------- */
const coach=$('coach'), hole=$('coachHole'), tip=$('coachTip'), arrow=$('coachArrow');
const STEPS=[
  {t:'Tocá un cuadro de la pared',x:'Así lo seleccionás para cambiarle el diseño, la medida o el marco.',el:()=>root.querySelector('.slot.active')||root.querySelector('.slot'),tab:'cuadro'},
  {t:'Elegí diseño, medida y marco',x:'Acá ves los diseños que combinan con tu pared, las medidas, el color del marco y si lo querés con margen blanco.',el:()=>$('slotsec'),tab:'cuadro',panel:true},
  {t:'Sumá o sacá cuadros',x:'Con − y + armás un set de 1 a 8 cuadros y elegís cómo acomodarlos.',el:()=>narrow()?root.querySelector('.tabbar [data-tab="dispo"]'):root.querySelector('[data-sec="dispo"]'),tab:null,panel:true},
  {t:'Probalo en tu casa',x:'Subí una foto de tu pared y te mostramos cómo queda, a escala real.',el:()=>$('photoOpen'),tab:'pared',panel:true},
  {t:'Comprá tu set',x:'Cuando te guste, tocá "Comprar el set": pagás y te llega a tu casa, listo para colgar.',el:()=>$('buy'),tab:'cuadro'}
];
let step=-1;
function showStep(i){
  step=i; const S=STEPS[i]; if(!S){endTour();return;}
  if(S.tab)setTab(S.tab);
  coach.hidden=false;
  $('coachStep').textContent=`Paso ${i+1} de ${STEPS.length}`;
  $('coachTitle').textContent=S.t;
  $('coachText').textContent=S.x;
  $('coachNext').textContent=i===STEPS.length-1?'¡Empezar!':'Siguiente →';
  const el=S.el();
  if(el&&S.panel){const sc=narrow()?root.querySelector('.stagecol').offsetHeight:0;const y=el.getBoundingClientRect().top+window.scrollY-sc-24;window.scrollTo({top:Math.max(0,y),behavior:'auto'});}
  else if(i===0)window.scrollTo({top:host.getBoundingClientRect().top+window.scrollY-10,behavior:'auto'});
  requestAnimationFrame(placeCoach);
}
function placeCoach(){
  if(coach.hidden||step<0)return; const el=STEPS[step].el(); if(!el)return;
  const r=el.getBoundingClientRect(), pad=6, vw=window.innerWidth, vh=window.innerHeight;
  hole.style.left=(r.left-pad)+'px'; hole.style.top=(r.top-pad)+'px'; hole.style.width=(r.width+pad*2)+'px'; hole.style.height=Math.min(r.height+pad*2,vh)+'px';
  const tw=Math.min(320,vw-32); tip.style.width=tw+'px';
  const th=tip.offsetHeight; let left=Math.min(Math.max(16,r.left+r.width/2-tw/2),vw-tw-16);
  const below=r.bottom+pad+14+th<vh-8, top=below?r.bottom+pad+14:Math.max(8,r.top-pad-14-th);
  tip.style.left=left+'px'; tip.style.top=top+'px';
  arrow.className='coachArrow '+(below?'up':'down');
  arrow.style.left=Math.min(Math.max(14,r.left+r.width/2-left-9),tw-32)+'px';
}
function endTour(){coach.hidden=true;step=-1;try{localStorage.setItem('thd_tour','1');}catch(e){}}
$('coachNext').onclick=()=>showStep(step+1);
$('coachSkip').onclick=endTour;
$('howBtn').onclick=()=>showStep(0);
window.addEventListener('scroll',()=>requestAnimationFrame(placeCoach),{passive:true});
window.addEventListener('resize',()=>setTimeout(placeCoach,120));

boot();
})();
